<script>
import baseMixins from '@/plans/ZOOM_MEETING/config/base';

export default {
  mixins: [baseMixins],
  data() {
    return {
      showPlanDetail: false,
      isExpanded: false,
      canExpand: false,
    };
  },
  computed: {
    showExploreLink() {
      return false;
    },
    licenseAlertDesc() {
      return this.mx_defLicenseAlertDesc;
    },
    canSwitchCategory() {
      return false;
    },
    minHost() {
      return 1;
    },
    maxHost() {
      return 999;
    },
    isNormalCase() {
      return false;
    },
  }
};
</script>
